"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCompletedLessonUuids = void 0;
/* eslint-disable import/prefer-default-export */
exports.mockCompletedLessonUuids = {
    lessons: ['636b793e8408832e2f04b2dcX'],
};
